module.exports = __webpack_public_path__ + "assets/img/Australian-Seniors-Landing-Page-w720.235ec4fd.jpg";